import { ProfileStep } from "../../../types/personShow";
import { ModalProfileState } from "./types";

export const keyMap: Record<ProfileStep['key'], keyof ModalProfileState> = {
  introduction: 'introduction',
  activity: 'activity',
  slogan: 'slogan',
  favorite_brands: 'favoriteBrands',
  educational_histories: 'educationalHistories',
  career_histories: 'careerHistories',
  // keyMapとしては不使用
  resume: 'resume',
  job_resume: 'job_resume',
};
